import React from 'react';
import { ExternalLink, Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { projects } from '../mock';

const Projects = ({ isVisible }) => {
  return (
    <section id="projects" data-section className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        <div
          className={`transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 text-center mb-4">
            Projects & Case Studies
          </h2>
          <div className="w-24 h-1 bg-blue-700 mx-auto mb-12"></div>

          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">
            {projects.map((project, index) => (
              <Card
                key={project.id}
                className="border-2 border-slate-200 hover:border-blue-700 overflow-hidden group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                style={{
                  transitionDelay: `${index * 100}ms`
                }}
              >
                <div className="relative overflow-hidden h-48">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4">
                    <Badge className="bg-blue-700 text-white">{project.category}</Badge>
                  </div>
                </div>
                <CardHeader>
                  <div className="flex items-start justify-between">
                    <CardTitle className="text-xl text-blue-900">{project.title}</CardTitle>
                    <div className="flex items-center gap-1 text-slate-500">
                      <Calendar size={14} />
                      <span className="text-sm">{project.period}</span>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-slate-700 mb-4">{project.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag, idx) => (
                      <Badge key={idx} variant="secondary" className="bg-slate-100 text-slate-700">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;